import { schema } from 'normalizr';

export const processTypeRefSchema = new schema.Entity('processTypeRefs', {}, { idAttribute: 'Code' });
export const processTypeRefListSchema = [processTypeRefSchema];
export const processTypeSchema = new schema.Entity('processTypes', {}, { idAttribute: 'ProcessTypeId' });
export const processTypeListSchema = [processTypeSchema];
